export default function SafetyPage() {
  const items = [
    { title: '双重认证', desc: '绑定手机和谷歌验证器，登录和敏感操作时需二次确认，有效防止账户被盗' },
    { title: '反钓鱼码', desc: '设置专属反钓鱼码，收到的官方邮件中将包含此代码，帮助识别钓鱼邮件' },
    { title: 'API权限管理', desc: '为API密钥设置精确的IP白名单和操作权限，避免API泄露风险' },
    { title: '提现白名单', desc: '设置仅允许向已审核的地址提现，减少资产被转走的风险' },
    { title: '登录设备管理', desc: '定期检查登录记录，移除不认识的设备，防止未授权访问' },
  ]

  return (
    <div className="pt-24 pb-20" data-page-container>
      <div className="max-w-5xl mx-auto px-6">
        <div className="mb-12">
          <h1 className="text-4xl md:text-5xl font-bold mb-6"><span className="gradient-text">易欧账户安全指南</span></h1>
          <p className="text-muted text-lg leading-relaxed max-w-3xl">
            从基础安全设置开始，逐步提升账户防护等级。
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-unique-module="account-security-measures">
          {items.map((item, i) => (
            <div key={i} className="cyber-card p-8">
              <div className="w-10 h-10 rounded-lg bg-accent/10 flex items-center justify-center mb-4 font-mono">
                <span className="text-accent font-bold">{String(i + 1).padStart(2, '0')}</span>
              </div>
              <h2 className="text-xl font-semibold text-cyber-text mb-3">{item.title}</h2>
              <p className="text-muted leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 p-6 cyber-card">
          <h2 className="text-lg font-semibold text-cyber-text mb-3">安全操作建议</h2>
          <ul className="space-y-2 text-muted text-sm">
            <li className="flex items-center gap-2"><span className="text-accent-2">&gt;</span> 不在第三方网站输入账户密码</li>
            <li className="flex items-center gap-2"><span className="text-accent-2">&gt;</span> 定期修改登录密码和资金密码</li>
            <li className="flex items-center gap-2"><span className="text-accent-2">&gt;</span> 警惕冒充客服的诈骗电话和短信</li>
            <li className="flex items-center gap-2"><span className="text-accent-2">&gt;</span> 仅从官方渠道下载APP</li>
          </ul>
        </div>
      </div>
    </div>
  )
}
